import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { IndexedDbService } from '../indexed-db/indexed-db.service';
import { IsDeviceOnlineService } from '../is-online/is-online.service';

@Injectable({
  providedIn: 'root'
})
export class LocationService {
  constructor(
    private http: HttpClient,
    private readonly _isOnline: IsDeviceOnlineService,
    private readonly _indexedDbService: IndexedDbService
  ) {}

  private headers: HttpHeaders = new HttpHeaders({
    'Access-Control-Allow-Headers': '*'
  });

  private geocodeAPI: string = 'https://maps.googleapis.com/maps/api/geocode/json?';
  private apiKey: string = 'AIzaSyAmA2B8tnEbUxUMKQZ03a_Fui3sXs4nHqw';

  geocodeLocation(lat: number, lng: number): Observable<any> {
    return this.http.get(`${this.geocodeAPI}latlng=${lat},${lng}&key=${this.apiKey}`);
  }

  getCities() {
    // return this._isOnline.networkStatus$.pipe(
    //   tap((status) => {
    //     console.log('status is:', status);
    //   }),
    //   switchMap((status) => {
    //     switch (status) {
    //       case 'offline': {
    //         console.log('inside offline block');

    //         return this._indexedDbService.getDataUsingApiPath({ apiPath }).pipe(
    //           tap((data) => {
    //             console.log(
    //               'received data in LocationService class from getDataUsingApiPath'
    //             );
    //             console.log('data is', data);
    //           })
    //         );

    //         // ---------------------
    //         // return this._indexedDbService
    //         //   .getCitiesFromLocalDatabaseImproved({
    //         //     storeName: 'cities',
    //         //   })
    //         //   .pipe(
    //         //     tap((data) => {
    //         //       console.log('received data in  local service block:', data);
    //         //     })
    //         //   );

    //         // ---------------------
    //         // return this._indexedDbService
    //         //   .getCitiesFromLocalDatabase({
    //         //     storeName: 'cities',
    //         //   })
    //         //   .pipe(
    //         //     tap((data) => {
    //         //       console.log('received data in getCities block:', data);
    //         //     })
    //         //   );
    //       }
    //       case 'online': {
    //         console.log('inside online block');
    //         return this.http.get(completeURL);
    //       }
    //     }
    //   })
    // );

    return this.http.get(`${environment.api}/car/get/cities`).pipe(
      tap((data) => {
        // console.log('data received is 457756:', data);
      })
    );
  }

  getAreas(data: any) {
    return this.http.post(`${environment.api}/car/get/location`, data);

    // return this._isOnline.networkStatus$.pipe(
    //   switchMap((status) => {
    //     switch (status) {
    //       case 'offline': {
    //         return this._indexedDbService.getAreasFromCities({
    //           cityId: data.city_id,
    //         });
    //       }
    //       case 'online': {
    //         return this.http.post(`${environment.api}/car/get/location`, data);
    //       }
    //     }
    //   })
    // );
  }
}
